module.exports = __webpack_public_path__ + "img/panelView_baoSteel_4_3_.0855bdea.png";